module.exports = __webpack_public_path__ + "images/23804f1209fa050837d914eff0b436b2.svg";